import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Flex, RectangularButton } from '@resideo/blueprint-react';
import ModalHeader from 'components/common/ModalHeader';

export const UnableToDeleteUserModal = ({
  onCancel,
  message,
}: {
  onCancel: () => void;
  message?: string;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader
        title={t('deleteUser.unableToDeleteAccountTitle')}
        textAlign='center'
        closeModal={onCancel}
      />
      <Text
        data-test-unable-to-delete-user-modal-text1
        marginBottom='small'
        paddingBottom={'medium'}
        justifyContent='center'>
        {message || t('deleteUser.unableToDeleteAccountText1')}
      </Text>
      <Text
        data-test-unable-to-delete-user-modal-text2
        marginBottom='large'
        justifyContent='center'>
        {t('deleteUser.unableToDeleteAccountText2')}
      </Text>
      <Text
        data-test-unable-to-delete-user-modal-text3
        marginBottom='large'
        justifyContent='center'>
        {t('deleteUser.unableToDeleteAccountText3')}
      </Text>
      <Flex justifyContent='flex-end'>
        <RectangularButton
          data-test-unable-to-delete-user-modal-close-button
          type='button'
          variant='secondary'
          onClick={onCancel}>
          {t('common.close')}
        </RectangularButton>
      </Flex>
    </>
  );
};
